<template>
  <v-layout row justify-center>
    <v-dialog v-model="showUserFinancialCard" max-width="740px"
      transition="dialog-bottom-transition" @keydown.esc="showUserFinancialCard = false">

      <v-card v-if="userMP && userMP.id">
        <v-toolbar color="blue-grey lighten-5">
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-xs-center">CARTÕES</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="showUserFinancialCard = false">
            <v-icon>fal fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <p class="text-xs-center">
            Cadastre ao menos um cartão.
          </p>
          <v-alert icon="fal fa-info-circle" :value="userMP && userMP.cards && userMP.cards.length && !userMP.default_card" type="error">
            É necessário deixar um cartão selecionado como principal.
          </v-alert>
          <user-financial-cards-list :userMP="userMP" v-if="userMP.cards.length"></user-financial-cards-list>
          <div class="text-xs-center" v-if="!addNewCard">
            <v-btn @click.stop="addNewCard = true" small round large depressed color="success">
              Adicionar novo cartão
            </v-btn>
          </div>

          <v-container grid-list-md v-if="!userMP.cards.length || addNewCard">
            <v-divider></v-divider>
            <form action="" method="post" id="pay" name="pay">
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field name="email" v-model="userMP.email" label="Email"
                    outline readonly required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field data-checkout="cardholderName" v-model="userMP.first_name"
                    outline label="Nome (como consta no cartão)" required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field prepend-inner-icon="" :mask="'credit-card'" label="Número do cartão" data-checkout="cardNumber"
                    outline @input="guessingPaymentMethod($event)" required>
                    <v-fade-transition slot="prepend">
                      <img v-if="paymentMethodInfo && paymentMethodInfo[0] && paymentMethodInfo[0].secure_thumbnail"
                        :src="paymentMethodInfo[0].secure_thumbnail">
                      <v-icon v-else>fal fa-credit-card</v-icon>
                    </v-fade-transition>
                  </v-text-field>
                </v-flex>

                <v-flex xs12 md4>
                  <v-text-field type="number" label="Código de segurança" placeholder="123"
                    outline data-checkout="securityCode" required></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field type="number" label="Mês de Expiração" placeholder="12"
                    outline data-checkout="cardExpirationMonth" required></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field type="number" label="Ano de Expiração" placeholder="2030"
                    outline data-checkout="cardExpirationYear" required></v-text-field>
                </v-flex>

                <v-flex xs4 md2>
                  <v-text-field label="Tipo" v-model="userMP.identification.type"
                    outline placeholder="Documento" data-checkout="docType" required></v-text-field>
                </v-flex>
                <v-flex xs8 md10>
                  <v-text-field label="Número do documento" v-model="userMP.identification.number"
                    outline placeholder="123" data-checkout="docNumber" required></v-text-field>
                </v-flex>
                <input type="hidden" name="paymentMethodId" />
              </v-layout>
            </form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click.stop="save()" round large depressed color="success"
                :loading="loadingRequest">
                Salvar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'

import UserFinancialCardsList from '@/components/user/financial/UserFinancialCardsList'

export default {
  data: () => ({
    showUserFinancialCard: false,
    loadingRequest: false,
    addNewCard: false,
    cardToken: {},
    paymentMethodInfo: {},
    userMP: {}
  }),

  methods: {
    getBin () {
      const ccNumber = document.querySelector('input[data-checkout="cardNumber"]')
      return ccNumber.value.replace(/[ .-]/g, '').slice(0, 6)
    },

    guessingPaymentMethod (event) {
      const bin = this.getBin()

      if (event.type === 'keyup') {
        if (bin.length >= 6) {
          Mercadopago.getPaymentMethod({
            'bin': bin
          }, this.setPaymentMethodInfo)
        }
      } else {
        setTimeout(() => {
          if (bin.length >= 6) {
            Mercadopago.getPaymentMethod({
              'bin': bin
            }, this.setPaymentMethodInfo)
          }
        }, 100)
      }
    },

    setPaymentMethodInfo (status, response) {
      if (status === 200) {
        this.paymentMethodInfo = response
        // do somethings ex: show logo of the payment method
        const form = document.querySelector('#pay')

        if (document.querySelector('input[name=paymentMethodId]') == null) {
          const paymentMethod = document.createElement('input')
          paymentMethod.setAttribute('name', 'paymentMethodId')
          paymentMethod.setAttribute('type', 'hidden')
          paymentMethod.setAttribute('value', response[0].id)

          form.appendChild(paymentMethod)
        } else {
          document.querySelector('input[name=paymentMethodId]').value = response[0].id
        }
      }
    },

    save () {
      this.loadingRequest = true
      const $form = document.querySelector('#pay')
      Mercadopago.createToken($form, (status, response) => {
        if (status !== 200 && status !== 201) {
          this.loadingRequest = false
          EventBus.$emit('showSnackbar', { message: 'Preencha os campos corretamente', color: 'error' })
        } else {
          const form = document.querySelector('#pay')
          const card = document.createElement('input')
          card.setAttribute('name', 'token')
          card.setAttribute('type', 'hidden')
          card.setAttribute('value', response.id)
          form.appendChild(card)
          this.cardToken = response
          this.saveCreditCard()
        }
      })
    },

    saveCreditCard () {
      const path = `${API.mpCustomersCards}/customers/${this.userMP.id}`

      const params = {
        token: this.cardToken.id
      }

      axios.post(path, params).then(() => {
        EventBus.$emit('loadUserOnMP')
        EventBus.$emit('showSnackbar', { message: 'Cartão salvo com sucesso!', color: 'success' })
        this.showUserFinancialCard = false
        this.loadingRequest = false
        window.location.reload()
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', { message: 'Erro ao salvar o cartão', color: 'error' })
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('showUserFinancialCard')
    EventBus.$off('showUserFinancialCardData')
  },

  mounted () {
    EventBus.$on('showUserFinancialCard', data => {
      this.showUserFinancialCard = data
    })

    EventBus.$on('showUserFinancialCardData', data => {
      this.userMP = data
    })
  },

  components: {
    UserFinancialCardsList
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/financial/UserFinancialCard.vue